import Footer from "@components/shared/footer";
import Header from "@components/shared/header";
import { FC } from "react";
import { Outlet } from "react-router-dom";

const MainLayout: FC = () => {
    return (
        <>
            <div className="md:h-[calc(100svh-2rem)]  md:max-h-[calc(100svh-2rem)] min-h-fit md:max-h-auto gap-8 flex flex-col max-w-7xl items-center md:px-8 px-4 box-border">
                <Header />
                <Outlet />
            </div>
            <Footer />
        </>
    );
};

export default MainLayout;
